import * as React from 'react';
import Master from './Layouts/MasterContainer';
import {BrowserRouter as Router} from 'react-router-dom';
import {ToastProvider} from 'react-toast-notifications'

export class App extends React.Component {
    render() {
        return <ToastProvider>
            <Router>
                <Master></Master>
            </Router>
        </ToastProvider>;
    }
}
